import React               from 'react';
import { Table }           from 'react-bootstrap';
import PropTypes           from 'prop-types';
import styled              from 'styled-components';
import { sortArrayObject } from 'helpers';
import { createUniqueStr } from 'helpers';
import { Dl, Dt, Dd }      from 'styles/util';

/**
 * [共通パーツ]ソートテーブルコンポーネント
 */
const SortTable = (props) => {
  const { state, headers, options } = props;
  const [ localState, setItems ] = React.useState({ status: createUniqueStr(), items: state.items });
  const [ setting, setSetting ] = React.useState({ isAsc: true, className: 'fa-sort-asc' });
  const [ currentSortKey, setCurrentSortKey ] = React.useState(null); // 現在のソートキーをセットする

  // propsで受け取ったstateのステータスが更新される度に下記の処理を実行する
  React.useEffect(() => {
    let tmpItems = state.items;
    // 初期表示時に指定されたキーでソートする
    if (options !== undefined && options.sort_key !== undefined) {
      setCurrentSortKey(options.sort_key);
      tmpItems = sortArrayObject(tmpItems, options.sort_key, true);
    }
    setItems({ status: createUniqueStr(), items: tmpItems });
  },[state.status]);

  /**
   * 指定されたキー(カラム名)でテーブルをソートする
   * @param {string}  key   カラム
   * @param {boolean} isAsc true:昇順/false:降順
   */
  const handleSort = (key, isAsc) => {
    const isAscFlg = isAsc;
    const className = isAscFlg ? 'fa-sort-asc' : 'fa-sort-desc';
    setSetting({ isAsc: isAscFlg, className: className });
    setItems({ status: createUniqueStr(), items: sortArrayObject(localState.items, key, isAscFlg) });
  };

  /**
   * 絞り込み検索
   * @param {string} value 
   */
  const handleFilter = value => {
    let tmpItems = state.items;
    const radioButtons = props.options.radio_buttons;
    const indexKey =  props.options.filter_column;
    for (const key in radioButtons) {
      if (radioButtons[key].value !== 'All' && radioButtons[key].value === value) {
        tmpItems = state.items.filter((item) => item[indexKey].indexOf(radioButtons[key].value) === 0);
        break;
      }
    }
    setItems({ status: createUniqueStr(), items: tmpItems });
  };

  /**
   * テーブルヘッダー Itemsのレンダリング
   */
  const renderHeaderItems = () => {
    return headers.items.map((item, index) => {
      const { attribute, sort } = item;
      return (<th
        key={index}
        {...attribute}
        {...item.style}
      >
        {item.name}
        { options !== undefined && 
          options.sort &&                       // ソート機能オン
          ( sort.key !== undefined              // ソートキーが指定されている
            && sort.key === currentSortKey ?    // 現在のソート = ソートキーである
            // ▼▲ボタンを表示
            <Button onClick={() => handleSort(sort.key, !setting.isAsc)}>
              <I className={setting.className} aria-hidden='true'></I>
            </Button> : 
            // - ボタンを表示
            <Button onClick={() => {
              setCurrentSortKey(sort.key);
              handleSort(sort.key, true); // ソートを切り替えたときの並び順は昇順
            }}>
              <I className="fa-minus" aria-hidden="true"></I>
            </Button>
          )
        }
      </th>
      );
    });
  };

  // テーブルヘッダー operationsのレンダリング
  const renderHeaderOperations = () => {
    const total = headers.operations.total;
    const name  = headers.operations.name !== undefined ? headers.operations.name : '';
    if (total > 0) {
      return (
        <th colSpan={total} style={{maxWidth: 80*total, width: 80*total}}>
          {name}
        </th>
      );
    } else {
      return ;
    }
  };

  return (
    <>
      { state.items.length > 0 && 
        props.options !== undefined && 
        props.options.filter === true && 
        props.options.filter_column !== undefined && 
        props.options.radio_buttons.length > 0 && 
        <Dl>
          <Dt data-testid='narrow-down-filename'>
          File name
          </Dt>
          <Dd>
            {
              props.options.radio_buttons.map((input, index) => (
                <React.Fragment key={index}>
                  <Input
                    type='radio'
                    name='filename'
                    {...input}
                    onChange={(e) => handleFilter(e.target.value)}
                  />
                  <Label htmlFor='all'>{input.label}</Label>
                </React.Fragment>
              ))
            }
          </Dd>
        </Dl>
      }
      {/* テーブルが空でない且つコンポーネントが指定されている場合はテーブルをレンダリングする */}
      { state.items.length > 0 && 
        props.component !== null && 
        <Table striped bordered hover data-testid='sort-table'>
          <thead>
            <tr>
              {renderHeaderItems()}
              {renderHeaderOperations()}
            </tr>
          </thead>
          <tbody>
            {localState.items.map((item, index) => (<props.component key={index} item={item} func={state.func}/>))}
          </tbody>
        </Table>
      }
    </>
  );
};

SortTable.defaultProps = {
  state: {
    status: '',
    items: [],
    func: {},
  }
};
SortTable.propTypes = {
  headers: PropTypes.object,
  state: PropTypes.object,
  options: PropTypes.object,
  component: PropTypes.func,
};
const Button = styled.button`
  background-color: transparent;
  border: 0px;
  outline: none !important;
`;
const I = styled.i`
  margin-left: 10px;
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
`;
const Input = styled.input`
  margin-right: 10px;
`;
const Label = styled.label`
  margin-right: 20px;
`;
export default SortTable;
